import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { CoffeeProvider } from "@/context/CoffeeContext";
import AuthPage from "@/pages/AuthPage";
import Dashboard from "@/pages/Dashboard";
import NoteEditor from "@/pages/NoteEditor";
import MindMapEditor from "@/pages/MindMapEditor";
import Bitacora from "@/pages/Bitacora";
import Documents from "@/pages/Documents";
import LinkDevice from "@/pages/LinkDevice";
import PairDevice from "@/pages/PairDevice";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import PublicView from "@/pages/PublicView";
import Agenda from "@/pages/Agenda";
import PdfEditor from "@/pages/PdfEditor";
import Papelera from "@/pages/Papelera";
import SheetEditor from "@/pages/SheetEditor";
import AdminPanel from "@/pages/AdminPanel";
import Finanzas from "@/pages/Finanzas";
import Tutoriales from "@/pages/Tutoriales";
import MisArchivos from "@/pages/MisArchivos";
import MovementMap from "@/pages/MovementMap";
import Board from "@/pages/Board";
import LedgerMap from "@/pages/LedgerMap";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center font-mono2 text-sm">
        Cargando...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <CoffeeProvider>
            <Toaster position="top-center" richColors theme="system" />
            <Routes>
              <Route path="/login" element={<PublicOnly><AuthPage mode="login" /></PublicOnly>} />
              <Route path="/register" element={<PublicOnly><AuthPage mode="register" /></PublicOnly>} />
              <Route path="/pair" element={<PairDevice />} />
              <Route path="/recuperar" element={<PublicOnly><ForgotPassword /></PublicOnly>} />
              <Route path="/restablecer" element={<ResetPassword />} />
              <Route path="/p/:token" element={<PublicView />} />
              <Route path="/" element={<Protected><Dashboard /></Protected>} />
              <Route path="/note/:id" element={<Protected><NoteEditor /></Protected>} />
              <Route path="/mindmap/:id" element={<Protected><MindMapEditor /></Protected>} />
              <Route path="/hoja/:id" element={<Protected><SheetEditor /></Protected>} />
              <Route path="/movimientos/:id" element={<Protected><MovementMap /></Protected>} />
              <Route path="/pizarra/:id" element={<Protected><Board /></Protected>} />
              <Route path="/contable/:id" element={<Protected><LedgerMap /></Protected>} />
              <Route path="/bitacora" element={<Protected><Bitacora /></Protected>} />
              <Route path="/agenda" element={<Protected><Agenda /></Protected>} />
              <Route path="/documentos" element={<Protected><Documents /></Protected>} />
              <Route path="/editar-pdf/:id" element={<Protected><PdfEditor /></Protected>} />
              <Route path="/papelera" element={<Protected><Papelera /></Protected>} />
              <Route path="/admin" element={<Protected><AdminPanel /></Protected>} />
              <Route path="/finanzas" element={<Protected><Finanzas /></Protected>} />
              <Route path="/tutoriales" element={<Protected><Tutoriales /></Protected>} />
              <Route path="/mis-archivos" element={<Protected><MisArchivos /></Protected>} />
              <Route path="/link" element={<Protected><LinkDevice /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            </CoffeeProvider>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
